// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1MJRz","messages":"Chat_messages__1c93y","dateDivider":"Chat_dateDivider__2XwUM"};